import type { Event, EventHint } from "@sentry/react";

export type BeforeSend = (
  event: Event,
  hint: EventHint,
) => PromiseLike<Event | null> | Event | null;

export const composeBeforeSend = (
  ...args: (BeforeSend | null | undefined)[]
): BeforeSend => {
  const fns = args.filter((fn): fn is BeforeSend => typeof fn === "function");

  return async (event, hint) => {
    let result: Event | null = event;
    for (const fn of fns) {
      result = await fn(result!, hint);
      if (!result) return null;
    }

    return result!;
  };
};
